module.exports = __webpack_public_path__ + "pinterest-shadow.c032e6b910883df7fb023beda6443588.svg";